import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
// import { Helmet, HelmetProvider } from 'react-helmet-async';
// import { EN, RU } from './constants/languages';
import './index.css';
import App from './components/App/App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <HelmetProvider>
      <Helmet htmlAttributes={{ lang: EN.lang }}/> */}
      <BrowserRouter>
        <App />
      </BrowserRouter>
    {/* </HelmetProvider> */}
  </React.StrictMode>
);
